export const underline = {
  attrs: {
    class: { default: 'underline' }
  },
  parseDOM: [{ tag: `span.underline` }],
  toDOM: function (mark) {
    return ['span', mark.attrs]
  }
}
